import UIList from 'UIComponents/list/UIList';
import styled, { theme } from '../utils/Styling';
const DividedList = styled(UIList).attrs({
  inline: true,
  use: 'inline-divided'
}).withConfig({
  displayName: "DividedList",
  componentId: "lzdpt7-0"
})(["display:flex !important;&& > li + li{background-image:linear-gradient( to bottom,", ",", " ) !important;}"], theme.colors.PANTERA, theme.colors.PANTERA);
export default DividedList;